<template>
  <div
    class="under-menu-component"
    :class="[isMobile() ? 'mobile-under-menu-component' : '']"
    :style="transformCoef"
  >
    <div class="component-item visibility-none">
      <time-keeper-component />
    </div>
  </div>
</template>

<script lang="ts">
// External Package codes
import { WindowAspect } from '@powerplay/core-minigames-ui-ssm'

// Game Components
import TimeKeeperComponent from '@/components/TimeKeeperComponent/index.vue'

import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    TimeKeeperComponent
  },
  mixins: [WindowAspect],
  computed: {
    transformCoef() {

      return {
        transform: `scale(${this.scaleCoef})`,
        'transform-origin': '100% 0'
      }

    }
  },
})

</script>

<style lang="less" scoped>

.under-menu-component{
    position: absolute;
    right: 1%;
    top: 14%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &.mobile-under-menu-component {
        top: 14%;
    }
    .component-item {
        position: relative;
        margin-bottom: 15px;
    }

    .visibility-none {
        visibility: hidden;
    }

}

</style>
